export default __webpack_public_path__ + "static/media/icon-forward.1665c6ba.svg";